import React from 'react';
import { Box, Typography } from '@mui/material';
import { SANS } from './publicTokens';

/**
 * Franja de logos arriba del footer público: con quién está hecho DashFlow.
 * Va sobre fondo oscuro (el footer es tinta), por eso los logos se pasan a blanco.
 */
const PARTNERS = [
  { src: '/integraciones/meta.svg', alt: 'Meta', h: 17, title: 'API oficial de WhatsApp', sub: 'plataforma de Meta' },
  { src: '/integraciones/aws.svg', alt: 'AWS', h: 24, title: 'Infraestructura', sub: 'en AWS' },
  { src: '/integraciones/claude.svg', alt: 'Claude', h: 17, title: 'Claude for Startups', sub: 'programa de Anthropic' },
];

const PartnersStrip: React.FC = () => (
  <Box
    component="ul"
    aria-label="Plataformas y programas"
    sx={{
      listStyle: 'none',
      m: 0,
      p: 0,
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'center',
      gap: 1.5,
      mb: { xs: 5, md: 7 },
    }}
  >
    {PARTNERS.map((p) => (
      <Box
        component="li"
        key={p.alt}
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 2,
          px: 2.5,
          py: 1.6,
          width: { xs: '100%', sm: 'auto' },
          border: '1px solid rgba(255,255,255,0.12)',
          bgcolor: 'rgba(255,255,255,0.04)',
          borderRadius: '12px',
        }}
      >
        <Box sx={{ width: 92, display: 'flex', justifyContent: 'center', flexShrink: 0 }}>
          <Box
            component="img"
            src={p.src}
            alt={p.alt}
            loading="lazy"
            sx={{ height: p.h, width: 'auto', display: 'block', filter: 'brightness(0) invert(1)', opacity: 0.92 }}
          />
        </Box>
        <Box sx={{ width: '1px', alignSelf: 'stretch', bgcolor: 'rgba(255,255,255,0.14)' }} />
        <Box>
          <Typography sx={{ fontFamily: SANS, fontSize: '0.9rem', fontWeight: 600, color: 'rgba(255,255,255,0.92)', lineHeight: 1.25 }}>
            {p.title}
          </Typography>
          <Typography sx={{ fontFamily: SANS, fontSize: '0.8rem', color: 'rgba(255,255,255,0.5)', lineHeight: 1.3 }}>
            {p.sub}
          </Typography>
        </Box>
      </Box>
    ))}
  </Box>
);

export default PartnersStrip;
